module.exports = __webpack_public_path__ + "img/31.c0e34010.jpg";